import * as angular from "angular";
import {IController} from 'angular';
import * as _ from "lodash";
import {PdfFormTemplateModel} from "../../models/pdf-form-template.model";

export class PdfFormTemplateSelectComponent implements IController {

  selectedId: any;
  form: any;
  options: any;
  optionIds: any;
  name: string;
  ngPlaceholder: any;
  excludeIds: any;
  isDisabled: any;
  isRequired: boolean;
  allowGlobal: boolean;
  onChange: Function;

  private pdfFormTemplateRef: any;
  public selectedPdfFormTemplate: any;
  public selectedText: any;
  public inputName: any;

  /* @ngInject */
  constructor(private $mdPanel, private $pdfFormTemplates) {
    this.pdfFormTemplateRef = this.$pdfFormTemplates();
  }

  $onInit() {
    if (!this.name) {
      this.name = 'pdfFormTemplateSelect';
    } else {
      this.inputName = this.name + 'PdfFormTemplate';
    }
    this._setSelectedPdfFormTemplate();
  };

  $onChanges(changes) {
    if ((changes.selectedId && !changes.selectedId.isFirstChange())) {
      this._setSelectedPdfFormTemplate();
    }
  };


  onShowPanel($event) {

    if (!!this.isDisabled) {
      return;
    }

    const panelPosition = this.$mdPanel.newPanelPosition()
      .relativeTo($event.target)
      .addPanelPosition(
        this.$mdPanel.xPosition.CENTER,
        this.$mdPanel.yPosition.BELOW // yPosition.BELOW
      );

    const panelAnimation = this.$mdPanel.newPanelAnimation()
      .openFrom($event)
      .duration(200)
      .closeTo('.bringoz-select-input')
      .withAnimation(this.$mdPanel.animation.FADE);

    const selectedIdRef = this.selectedId;
    const optionsRef = this.options;
    const optionIdsRef = this.optionIds;
    const excludeIdsRef = this.excludeIds;
    const ngPlaceholderRef = this.ngPlaceholder;
    const allowGlobalRef = this.allowGlobal;

    const config = {
      attachTo: angular.element(document.body),
      controllerAs: 'ctrl',
      position: panelPosition,
      animation: panelAnimation,
      targetEvent: $event,
      template: '<bringoz-select-filter-panel ' +
        'type="ctrl.typeRef" ' +
        'selected-id="ctrl.selectedIdsRef" ' +
        'options="ctrl.optionsRef" ' +
        'option-ids="ctrl.optionIdsRef" ' +
        'ng-placeholder="ctrl.ngPlaceholderRef" ' +
        'panel-ref="ctrl.mdPanelRef" ' +
        'query-map="ctrl.queryMapRef" ' +
        'exclude-ids="ctrl.excludeIdsRef">' +
        '</bringoz-select-filter-panel>',
      controller: function () {
        this.typeRef = 'pdfFormTemplate';
        this.selectedIdsRef = selectedIdRef;
        this.optionsRef = optionsRef;
        this.optionIdsRef = optionIdsRef;
        this.ngPlaceholderRef = ngPlaceholderRef;
        this.excludeIdsRef = excludeIdsRef;
        this.queryMapRef = {
          allowGlobal: allowGlobalRef
        };
      },
      clickOutsideToClose: true,
      escapeToClose: true,
      focusOnOpen: true,
      zIndex: 80,
      onCloseSuccess: (panel, selectedId) => {
        if (selectedId === 'clickOutsideToClose' || selectedId === 'escapeToClose') {
          selectedId = selectedIdRef;
        }

        if (!selectedId) {
          this.onChange({pdfFormTemplate: undefined, id: undefined});
          panel.destroy();
        } else {
          if (!!this.options) {
            const pdfFormTemplate = _.find(this.options, (o) => {
              return o.id === selectedId;
            })
            this.onChange({pdfFormTemplate: pdfFormTemplate, id: selectedId});
            panel.destroy();
          } else {
            this.pdfFormTemplateRef.$asyncValues([selectedId])
              .then((pdfFormTemplates: PdfFormTemplateModel[]) => {
                this.onChange({pdfFormTemplate: pdfFormTemplates[0], id: selectedId});
                panel.destroy();
              });
          }
        }
      }
    };

    this.$mdPanel.open(config);
  }

  onResetFilter() {
    this.onChange({pdfFormTemplate: undefined});
  }

  private _setSelectedPdfFormTemplate() {
    if (!!this.selectedId) {
      if (!!this.options) {
        this.selectedPdfFormTemplate = _.find(this.options, (o) => {
          return o.id === this.selectedId;
        });
        this._setSelectedText();
      } else {
        this.pdfFormTemplateRef.$asyncValues([this.selectedId])
          .then((pdfFormTemplates: PdfFormTemplateModel[]) => {
            this.selectedPdfFormTemplate = pdfFormTemplates[0];
            this._setSelectedText()
          });
      }
    } else {
      this.selectedPdfFormTemplate = undefined;
      this._setSelectedText()
    }
  }

  private _setSelectedText() {
    this.selectedText = this.selectedPdfFormTemplate ? this.selectedPdfFormTemplate.templateName : '';
  }


}

angular
  .module('bringoz.admin.document-management')
  .component('pdfFormTemplateSelect', {
    require: {
      form: '^form'
    },
    bindings: {
      selectedId: '<?',
      options: '<?',
      optionIds: '<?',
      ngPlaceholder: '@?',
      name: '@?',
      excludeIds: '<?',
      isDisabled: '<?',
      isRequired: '<?',
      allowGlobal: '<?',
      onChange: '&'
    },
    template: require('./pdf-form-template-select.html').default,
    controller: PdfFormTemplateSelectComponent
  });
